import React from 'react';

import { StyledAccordionDetails } from './Accordion.styles';
import type { AccordionDetailsProps } from './Accordion.types';

/**
 * Primitive AccordionDetails component with responsive padding
 * Content area that displays when accordion is expanded
 */
export const AccordionDetails: React.FC<AccordionDetailsProps> = ({ children, ...props }) => {
  return <StyledAccordionDetails {...props}>{children}</StyledAccordionDetails>;
};